import { createSlice } from "@reduxjs/toolkit";
import {
    getAllBusinessCategoryAction,
    getBusinessCategoryAction,
    insertUpdateBusinessCategoryAction,
    BusinessCategoryChangeStatusACTION
} from "../../actions/settingActions/businessCategoryActions";
import { toast } from "react-toastify";
import { Enums } from "../../../helper/constants/enums";

const INITIAL_STATE = {
    BusinessCategory: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateBusinessCategory: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    selectedBusinessCategory: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    deleteBusinessCategory: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const BusinessCategoryReducer = createSlice({
    name: "BusinessCategory",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetBusinessCategoryDetailsState(state, action) {
            state.selectedBusinessCategory = INITIAL_STATE.selectedBusinessCategory;
            state.insertUpdateBusinessCategory = INITIAL_STATE.insertUpdateBusinessCategory;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllBusinessCategoryAction.fulfilled, (state, action) => {
            state.BusinessCategory.data = action.payload.data;
            state.BusinessCategory.apiMsg.status = action.meta.requestStatus;
            state.BusinessCategory.apiMsg.message = "success";
        });
        builder.addCase(getAllBusinessCategoryAction.pending, (state, action) => {
            state.BusinessCategory.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllBusinessCategoryAction.rejected, (state, action) => {
            state.BusinessCategory.apiMsg.message = action.error.message;
            state.BusinessCategory.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getBusinessCategoryAction.fulfilled, (state, action) => {
            state.selectedBusinessCategory.data = action.payload.data;
            state.selectedBusinessCategory.apiMsg.status = action.meta.requestStatus;
            state.selectedBusinessCategory.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getBusinessCategoryAction.pending, (state, action) => {
            state.selectedBusinessCategory.data = null;
            state.selectedBusinessCategory.apiMsg.message = action.meta.requestStatus;
            state.selectedBusinessCategory.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getBusinessCategoryAction.rejected, (state, action) => {
            state.selectedBusinessCategory.apiMsg.message = action.error.message;
            state.selectedBusinessCategory.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(
            insertUpdateBusinessCategoryAction.fulfilled,
            (state, action) => {
                if (action.meta.arg) {
                    const existingRecords = state.BusinessCategory.data.records;
                    const newData = action.meta.arg;
                    const index = existingRecords ? existingRecords.findIndex(record => record.businessCategoryID === newData.businessCategoryID) : -1;

                    if (!newData.businessCategoryID) {
                        newData.businessCategoryID = action.payload.data.data;
                    }

                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                            ...newData,
                        };
                    } else {
                        existingRecords.push({
                            businessCategoryID: newData.businessCategoryID,
                            name: newData.name,
                            active: newData.active
                        });
                        state.BusinessCategory.data.totalRecords = state.BusinessCategory.data.totalRecords + 1;
                    }

                    state.BusinessCategory.data.records = existingRecords;
                    state.insertUpdateBusinessCategory.data = {
                        businessCategoryID: newData.businessCategoryID,
                        name: newData.name,
                        active: newData.active
                    };
                }

                state.insertUpdateBusinessCategory.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateBusinessCategory.apiMsg.message = action.payload.message.message;
                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(
            insertUpdateBusinessCategoryAction.pending,
            (state, action) => {
                state.insertUpdateBusinessCategory.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateBusinessCategoryAction.rejected,
            (state, action) => {
                state.insertUpdateBusinessCategory.apiMsg.message = action.error.message;
                state.insertUpdateBusinessCategory.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );

        builder.addCase(BusinessCategoryChangeStatusACTION.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.BusinessCategory.data.records;
                const businessCategoryIDToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.businessCategoryID !== businessCategoryIDToDelete);
                state.BusinessCategory.data.records = updatedRecords;
                state.BusinessCategory.data.totalRecords = state.BusinessCategory.data.totalRecords - 1;
            } else {
                const newData = action.meta.arg;
                const existingRecords = state.BusinessCategory.data.records;
                const index = existingRecords.findIndex(record => record.businessCategoryID === newData.Id);

                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: newData.active,
                    };
                }

                state.BusinessCategory.data.records = existingRecords;
            }

            state.deleteBusinessCategory.apiMsg.status = action.meta.requestStatus;
            state.deleteBusinessCategory.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(BusinessCategoryChangeStatusACTION.pending, (state, action) => {
            state.deleteBusinessCategory.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(BusinessCategoryChangeStatusACTION.rejected, (state, action) => {
            state.deleteBusinessCategory.apiMsg.message = action.error.message;
            state.deleteBusinessCategory.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetBusinessCategoryDetailsState } = BusinessCategoryReducer.actions;
export default BusinessCategoryReducer.reducer;
